/**
 * @description: 品牌建站数据看板
 * @author: chenyang.peter
 * @email: chenyang.peter@bytedance.com
 *
 * @created: 2019-08-23 12:02:54
 * @Last Modified Time: 2019-08-23 12:02:54
*/
<template>
  <div id="app">
    <Header :isIndex="true"/>
    <main>
        <div class="slogan">
            <p class="slogan-title">灵感无限·能量无限</p>
            <p class="slogan-subtitle">四海潮生，听过最温柔的海潮，还想听你的故事</p>
            <a href="/shop/home"  class="write-story__btn">书写你的品牌故事<byted-icon name="angle-right" color="#fff" width="14px" height="14px" class="write-story__btn--icon"/></a>
        </div>
        <div class="wall" :class="{'fade-in': isReady}">
            <marquee :paused="paused" :duration="80">
                <img
                    v-for="(item, idx) in cases"
                    :key="idx"
                    :class="`case${idx+1}`"
                    :src="optimizeImg(item.src)"
                    :alt="item.alt"
                />
            </marquee>
        </div>
    </main>
    <footer>
        <div class="footer-inner">
            <div class="agreement-box">
                <a href="https://s3.pstatp.com/cdn/expire-1-s/account-center/user_agreement.html" target="_blank" class="agreement-btn">服务协议</a> | <a href="https://www.oceanengine.com/legal" target="_blank" class="agreement-btn">隐私条款</a>
            </div>
            <p class="copyright">Copyright © 2018-2020 Bytedance.All Rights Reserved</p>
        </div>
    </footer>
  </div>
</template>

<script>
import Header from '@/business/basic/Header';
import Marquee from '@/business/basic/Marquee';
import {isSupportWebp, optimizeImg} from '@/utils/optimize-img';

export default {
    name: 'App',
    components: {
        Header,
        Marquee
    },
    data () {
        return {
            paused: true,
            isReady: false,
            cases: [
                { src: '//p3-orange.byteorge.com/obj/ad-vangogh/file/1576478238099/c21f99e61767ea6e41e2e419893fe059', alt: 'vivo' },
                { src: '//p3-orange.byteorge.com/obj/ad-vangogh/file/1576478211138/4931ae1fcdb3ee3de07eda07f0e357b1', alt: 'honor' },
                { src: '//p3-orange.byteorge.com/obj/ad-vangogh/file/1576478259575/58cdd665c1323480c921f097e46f11f5', alt: 'midea' },
                { src: '//p3-orange.byteorge.com/obj/ad-vangogh/file/1576478285380/aba911108735c216e3e6eaf23db44813', alt: 'peak' },
                { src: '//p3-orange.byteorge.com/obj/ad-vangogh/file/1576478344601/702e36bc962e110cb76a4ac46627dd65', alt: 'rby' },
                { src: '//p3-orange.byteorge.com/obj/ad-vangogh/file/1576478310304/1640ca9f66ade4aaf8de05941882c042', alt: 'vivo' }
            ]
        };
    },
    methods: {
        optimizeImg
    },
    created () {
        isSupportWebp();
    },
    mounted () {
        this.$nextTick(() => {
            setTimeout(() => {
                this.isReady = true;
            }, 300);
            setTimeout(() => {
                this.paused = false;
            }, 1400);
        });
    }
};
</script>

<style lang="less" scoped>
#app {
    height: 100%;
    background-color: rgba(0,0,0,.4);
    a {
        &:hover,
        &:focus {
            text-decoration: none;
        }
    }
}
.slogan-wrap {
    position: absolute;
    top: 64px;
    left: 0;
    width: 100%;
    height: 100%;
}
.slogan {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1140px;
    transform: translate(-50%, -50%);
    text-align: center;
}
.slogan-title {
    margin-bottom: 16px;
    font-family: PingFangSC-Regular,PingFang SC;
    font-size: 64px;
    font-weight: 600;
    color: #fff;
    line-height: 64px;
    letter-spacing:8px;
}
.slogan-subtitle {
    margin-bottom: 32px;
    font-size: 20px;
    color: #fff;
    line-height: 1;
    letter-spacing: 10px;
}
.write-story__btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    width: 196px;
    height: 48px;
    background:rgba(255, 255, 255, .2);
    font-size: 16px;
    color: #fff;
    line-height: 48px;
    border-radius: 24px;
    &:hover {
        background:rgba(255, 255, 255, .5);
    }
}
.write-story__btn--icon {
    margin-left: 5px;
    border: 1px solid #fff;
    border-radius: 50%;
}
.wall {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    display: flex;
    width: 100%;
    height: 100%;
    img {
        height: 100%;
        max-height: 100%;
        opacity: 0;
    }
    &.fade-in {
        img {
            opacity: 1;
            // transition: opacity 300ms linear 100ms;
            transition-property: opacity;
            transition-duration: 1100ms;
            transition-timing-function: ease;
        }
    }
}
// case1 300ms
// case2 400ms
// case3 500ms
// case4 600ms
// case5 700ms
// case6 800ms
// case7 900ms
.generate-case-item(@n, @i: 1) when (@i =< @n) {
    .wall.fade-in .case@{i} {
        transition-delay: (200ms + 100ms * @i);
    }
    .generate-case-item(@n, (@i + 1));
}
.generate-case-item(7);
footer {
    position: absolute;
    bottom: 16px;
    left: 0;
    width: 100%;
    height: 34px;
}
.footer-inner {
    margin: 0 auto;
    width: 1140px;
    font-size: 12px;
    color: #bbb;
    line-height: 17px;
    text-align: center;
}
.agreement-btn {
    color: #bbb;
    &:hover {
        color: #fff;
    }
}
.copyright {
    margin-bottom: 0;
}
.marquee-item {
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
}
</style>
